import styled from 'styled-components';

export const SCModalOuterWrapper = styled.div`
    button {
        border-radius: 0;
    }
    padding-bottom: 36px;
`;
